import React from 'react'
import Traduction from 'Components/Traduction'
import Select from 'Components/Select'
import Constants from 'EurestoFonction/Constants'
import DataComponent from '../../../DataComponents/index'
import Grid from '@material-ui/core/Grid'
import User from 'EurestoClass/User'
import ApiRequest from 'EurestoApi/ApiRequest'
import EurestoForm from 'Components/Form'
import Utils from 'EurestoFonction/Utils'


const project = require('EurestoConfig/project.config')

export default class extends React.Component {
  constructor (props) {
    super(props)
    const newState = {
      ...props,
      action: props.action,
      key: Utils.getRandomNumber()
    }
    this.state = {
      saveState: { ...EurestoClone(newState)},
      ...newState
    }
  }

  componentDidMount () {
    if (this.state.action === 'update' || this.state.action === 'duplicate' || this.state.action === 'view') {
      this.getInfoTiers()
    }
  }

  getInfoTiers = async () => {
    const result = await ApiRequest(project.api + 'sdd', {
      requete: 'info_tiers',
      action: 'get',
      id: this.state.id
    }, { showAlertError: false })
    if(result && result.code === 1) {
      const newState = {
        defaultLibelle: result.results.libelle && result.results.libelle.length > 0 && result.results.libelle[0].text,
        libelle: result.results.libelle,
        type_saisie_id: result.results.type_saisie_id,
        autorisation_saisie: result.results.autorisation_saisie,
        classeurs: result.results.classeurs,
        actif: result.results.actif,
        key: Utils.getRandomNumber()
      }
      this.setState({
        saveState: { action: 'view', ...EurestoClone(this.state.saveState), ...EurestoClone(newState) },
        ...newState,
        key: Utils.getRandomNumber()
      }, this.forceUpdate)
    }
  }

  onChangeState = (e, name) => {
    this.setState({
      [name]: e,
    }, this.forceUpdate)
  }

  onCancel = () => {
    this.setState({
      libelle: undefined,
      type_saisie_id: undefined,
      autorisation_saisie: undefined,
      classeurs: undefined,
      actif: undefined,
      key: Utils.getRandomNumber(),
      action: 'add',
    }, () => this.props.onCancel())
  }

  onSave = async (action) => {
    const result = await ApiRequest(project.api + 'sdd', {
      requete: 'info_tiers',
      action: action === 'update' ? 'update' : 'add',
      id: this.state.id,
      libelle: this.state.libelle,
      type_saisie_id: this.state.type_saisie_id,
      classeurs: this.state.classeurs,
      actif: this.state.actif,
      autorisation_saisie: User.TypeAccess.get(Constants.access.EURESTO) ? this.state.autorisation_saisie : 1,
    })
    if (result.code === 1) {
      this.onCancel()
    }
  }

  onDelete = async () => {
    const r = await ApiRequest(project.api + 'sdd', {
      requete: 'info_tiers',
      action: 'delete',
      id: this.state.id,
    })
    if (r && r.code === 1) {
      this.setState({
        action: this.props.isAllow && (this.props.isAllow.add && 'add' || ' ')
      })
    }
  }

  onArchive = async () => {
    console.log('not done yet')
  }

  onView = (action) => {
    const newState = this.state.saveState
    newState.saveState = {...EurestoClone(this.state.saveState)}
      newState.key = Utils.getRandomNumber();
    const keys = Object.keys(this.state)
    const stateReset = keys.reduce((acc, v) => ({ ...acc, [v]: undefined }), {})
    this.setState({
      ...stateReset,
      ...newState
    }, action === 'add' && this.props.onCancel(false) || this.forceUpdate)
  }

  form = (disabled, autoFocus) => {
    return (
      <Grid key={this.state.key} container style={{ margin: 0, padding: 0 }} spacing={0} direction="column"
            justify="flex-start"
            alignItems="stretch">
        <Traduction
          key={autoFocus}
          autoFocus={autoFocus}
          title={EurestoI18n.t('commun:Nom')}
          onChange={this.onChangeState}
          name={'libelle'}
          disabled={disabled}
          data={this.state.libelle !== undefined ? this.state.libelle : []}
          type={Constants.typeSaisie.SaisieLibre}
        />
        <DataComponent
          title={EurestoI18n.t('commun:Type de saisie')}
          name="type_saisie_id"
          disabled={disabled}
          type={Constants.typeSaisie.ComboSimple}
          onChange={this.onChangeState}

          data={this.state.type_saisie_id}
          object={Constants.donnee.type_saisie}
          module={Constants.module.CRM}/>

        <DataComponent
          title={EurestoI18n.t('commun:Classeur')}
          name="classeurs"
          disabled={disabled}
          type={Constants.typeSaisie.ComboMulti}
          onChange={this.onChangeState}
          data={this.state.classeurs}
          object={Constants.donnee.classeur}
          module={Constants.module.SDD}
        />

        {User.TypeAccess.get(Constants.access.EURESTO) && <Select
          title={EurestoI18n.t('commun:Autorisation de saisie')}
          name="autorisation_saisie"
          disabled={disabled}
          options={Constants.usefullObjectStatic[Constants.module.CRM+'-'+Constants.donnee.type_saisie].autorisation.filter(o => o.condition ? o.condition() : true).map(o => ({
            label: o.libelle,
            value: o.id
          }))}
          value={this.state.autorisation_saisie !== undefined ? this.state.autorisation_saisie : -1}
          onChange={this.onChangeState}/>}

        {User.TypeAccess.get(Constants.access.EURESTO) && <Select
          title={EurestoI18n.t('commun:Accessible pour...')}
          name="actif"
          disabled={disabled}
          options={[
            {
              label: EurestoI18n.t('commun:Tous'),
              value: 1
            },
            {
              label: EurestoI18n.t('commun:Seulement Euresto'),
              value: 2
            },
            {
              label: EurestoI18n.t('commun:Tous sauf Euresto'),
              value: 3
            }
          ]}
          value={this.state.actif !== undefined ? this.state.actif : 1} onChange={this.onChangeState}/>}
      </Grid>
    )
  }

  render () {
    return (
      <EurestoForm key={this.state.key}
                   {...this.props.formProps}
                   libelle={this.state.defaultLibelle}
                   action={this.state.action}
                   isAllow={this.props.isAllow}
                   onSave={this.onSave}
                   onCancel={this.onCancel}
                   onDelete={this.onDelete}
                   onArchive={this.onArchive}
                   onView={this.onView}
                   libelleAdd={EurestoI18n.t('commun:Nouveau critère')}
                   children={this.form}/>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataForm/Template/Messagerie/InfoTiers.js